exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-33739ea6]:invalid{background-color:#ffbebe}", ""]);

// exports
